import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '80%',
        maxWidth: 500,
        backgroundColor: theme.palette.background.paper,
    },
}));


export default function PRConceptList(props) {
    const classes = useStyles();
    const { conceptChecked, setConceptChecked, handleConceptToggle, conceptData } = props;
    const conceptIsChecked = (concept_id) => {
        return conceptChecked.filter(concept => concept.id === concept_id).length > 0;
    }

    return (
        <Card className={classes.root} variant="outlined">
            <CardHeader
                title="Conceptos de Nomina"
                subheader="Elija los que aplique"
            />
            <CardContent>
                <List dense className={classes.root}>
                    {conceptData.map(({ id, code, name }) => {
                        const labelId = `checkbox-list-secondary-label-${name}`;
                        return (
                            <ListItem key={id} button>

                                <ListItemText id={labelId} primary={`${code} - ${name} `} />
                                <ListItemSecondaryAction>
                                    <Checkbox
                                        edge="end"
                                        onChange={handleConceptToggle(id, code, name)}
                                        // checked={conceptChecked.indexOf(id) !== -1}
                                        checked={conceptIsChecked(id)}
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        );
                    })}
                </List>
            </CardContent>

        </Card>
    );
}